export default {
  title: 'Tax & Currency',
  subtitle: 'Manage the tax categories used to price your menu items.',
};
